import React, { useEffect, useState } from "react";
import { Fields } from "uicomponents";
import qs from "query-string";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import config from "../../../config";
import useTranslation from "../../../hooks/useTranslation";

const initEmptyValue = {
  products: [],
  kitcheners: [],
  authors: [],
  categories: [],
  order_types: [],
  order_statuses: [],
  name: "",
};

const Filter = () => {
  const { tr } = useTranslation();

  const location = useLocation();
  const navigate = useNavigate();
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });

  const [formValues, setFormValues] = useState(initEmptyValue);
  const clearHandler = () => {
    setFormValues(initEmptyValue);
    navigate({
      search: qs.stringify(
        { start_at: query.start_at, end_at: query.end_at },
        { encode: false }
      ),
    });
  };

  console.log(formValues, "__________________formValues_____________________")
  const handleSubmit = () => {
    const {
      kitcheners,
      products,
      authors,
      categories,
      order_types,
      order_statuses,
      ...others
    } = formValues;
    let values = {
      ...others,
      kitcheners: kitcheners.reduce(
        (prev, curr) => [...prev, { name: curr.name, id: curr.id }],
        []
      ),
      products: products.reduce(
        (prev, curr) => [...prev, { name: curr.name, id: curr.id }],
        []
      ),
      authors: authors.reduce(
        (prev, curr) => [...prev, { name: curr.name, id: curr.id }],
        []
      ),
      categories: categories.reduce(
        (prev, curr) => [...prev, { name: curr.title, id: curr.value }],
        []
      ),
      order_types: order_types.reduce(
        (prev, curr) => [...prev, { name: curr.name, id: curr.id }],
        []
      ),
      order_statuses: order_statuses.reduce(
        (prev, curr) => [...prev, { name: curr.name, id: curr.id }],
        []
      ),
    };
    navigate({
      search: qs.stringify(
        {
          start_at: query.start_at,
          end_at: query.end_at,
          filter: JSON.stringify(values),
        },
        { encode: false }
      ),
    });
  };

  useEffect(() => {
    const initialFilter = query.filter ? JSON.parse(query.filter) : {};
    setFormValues({
      name: initialFilter.name || "",
      kitcheners: Array.isArray(initialFilter.kitcheners)
        ? initialFilter.kitcheners
        : [],
      products: Array.isArray(initialFilter.products)
        ? initialFilter.products
        : [],
      authors: Array.isArray(initialFilter.authors)
        ? initialFilter.authors
        : [],
      categories: Array.isArray(initialFilter.categories)
        ? initialFilter.categories
        : [],
      order_types: Array.isArray(initialFilter.order_types)
        ? initialFilter.order_types
        : [],
      order_statuses: Array.isArray(initialFilter.order_statuses)
        ? initialFilter.order_statuses
        : [],
    });
  }, []);

  return (
    <div className="filter-section">
      <div className="row">
        <div className="col-3">
          <Fields.InputS1Default
            size={"small"}
            placeholder={tr("Поиск")}
            value={formValues.name}
            className={"mb-10"}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                name: e.target.value,
              })
            }
          />
        </div>
        <div className="col-3">
          <Fields.AsyncSelectD1
            type="text"
            placeholder={tr("Выберите автора")}
            loadOptionsUrl={"/user/all"}
            optionLabel={"name"}
            isSearchable={true}
            isClearable={true}
            isMulti={true}
            hideSelectedOptions={false}
            size={"small"}
            className={"mb-10 multi-no-wrap"}
            handleChange={(option) => {
              if (option) {
                setFormValues({
                  ...formValues,
                  authors: option,
                });
              } else {
                setFormValues({
                  ...formValues,
                  authors: [],
                });
              }
            }}
            value={formValues.authors}
            loadOptionsParams={(search) => {
              return {
                include: "role",
                sort: "name",
                extra: {
                  name: search,
                  'roles': `${config.USER_ROLE_WAITER},${config.USER_ROLE_CASHIER}`,
                },
              };
            }}
          />
        </div>
        <div className="col-3">
          <Fields.AsyncSelectD1
            type="text"
            placeholder={tr("Выберите другого сотрудника")}
            loadOptionsUrl={"/user/all"}
            optionLabel={"name"}
            isSearchable={true}
            isClearable={true}
            isMulti={true}
            hideSelectedOptions={false}
            size={"small"}
            className={"mb-10 multi-no-wrap"}
            handleChange={(option) => {
              if (option) {
                setFormValues({
                  ...formValues,
                  kitcheners: option,
                });
              } else {
                setFormValues({
                  ...formValues,
                  kitcheners: [],
                });
              }
            }}
            value={formValues.kitcheners}
            loadOptionsParams={(search) => {
              return {
                filter: {
                  "role.role": "kitchener",
                },
                include: "role",
                sort: "name",
                extra: { name: search },
              };
            }}
          />
        </div>
        <div className="col-3">
          <Fields.AsyncSelectD1
            type="text"
            placeholder={tr("Продукт")}
            loadOptionsUrl={"/dishes"}
            optionLabel={"name"}
            isSearchable={true}
            isMulti={true}
            isClearable={true}
            size={"small"}
            className={"mb-10 multi-no-wrap"}
            handleChange={(option) => {
              if (option) {
                setFormValues({
                  ...formValues,
                  products: option,
                });
              } else {
                setFormValues({
                  ...formValues,
                  products: [],
                });
              }
            }}
            value={formValues.products}
            loadOptionsParams={(search) => {
              return {
                sort: "name",
                extra: { _query: search },
              };
            }}
          />
        </div>
        <div className="col-3">
          <Fields.SelectD1
            type="text"
            placeholder={tr("Выберите тип заказа")}
            optionLabel={"name"}
            optionValue={"id"}
            size={"small"}
            isSearchable={true}
            isClearable={true}
            isMulti={true}
            className={"mb-0"}
            options={[
              { id: config.ORDER_TYPE_DELIVERY, name: tr("Доставка") },
              { id: config.ORDER_TYPE_TAKEAWAY, name: tr("Собой") },
            ]}
            value={formValues.order_types}
            onChangeHandle={(option) => {
              if (option) {
                setFormValues({
                  ...formValues,
                  order_types: option,
                });
              } else {
                setFormValues({
                  ...formValues,
                  order_types: [],
                });
              }
            }}
          />
        </div>
        {/* <div className="col-3">
          <Fields.SelectD1
            type="text"
            placeholder={tr("Выберите статус заказа")}
            optionLabel={"name"}
            optionValue={"id"}
            size={"small"}
            isSearchable={true}
            isClearable={true}
            isMulti={true}
            className={"mb-0"}
            options={[
              { id: config.ORDER_STATUS_NEW, name: tr("Новый") },
              { id: config.ORDER_STATUS_COMPLETED, name: tr("Завершенный") },
            ]}
            value={formValues.order_statuses}
            onChangeHandle={(option) => {
              if (option) {
                setFormValues({
                  ...formValues,
                  order_statuses: option,
                });
              } else {
                setFormValues({
                  ...formValues,
                  order_statuses: [],
                });
              }
            }}
          />
        </div> */}
        <div className="col-3">
          {/* <Fields.AsyncSelectD1
            type="text"
            placeholder={tr("Категория")}
            loadOptionsUrl={"/categories"}
            optionLabel={"name"}
            isSearchable={true}
            isMulti={true}
            isClearable={true}
            size={"small"}
            className={"mb-10 multi-no-wrap"}
            handleChange={(option) => {
              if (option) {
                setFormValues({
                  ...formValues,
                  categories: option,
                });
              } else {
                setFormValues({
                  ...formValues,
                  categories: [],
                });
              }
            }}
            value={formValues.categories}
            loadOptionsParams={(search) => {
              return {
                // filter: {
                //   type: config.CATEGORY_DISH,
                // },
                sort: "name",
                extra: { name: search },
              };
            }}
          /> */}
          <Fields.AsyncNestedSelectD1
            placeholder={tr("Выберите категорию")}
            loadOptionsUrl="/categories"
            loadOptionsParams={(search) => ({
              sort: "name",
              include: "children",
              extra: { name: search || "" }
            })}
            optionLabel={(option) => option.name}
            isSearchable={true}
            isClearable={true}
            size="small"
            className="mb-0"
            isMulti={true}
            // handleChange={(options) => {
            //   if (options && options.length) {
            //     const ids = options.join(",");
            //     setCategory(options);
            //     handleSearch({ category: ids });
            //   } else {
            //     setCategory([]);
            //     handleSearch({ category: null });
            //   }
            // }}
            handleChange={(opt, options, option) => {
              if (option) {
                setFormValues({
                  ...formValues,
                  categories: option,
                });
              } else {
                setFormValues({
                  ...formValues,
                  categories: [],
                });
              }
            }}
            value={formValues.categories}
          />
        </div>
        <div className="col-3"></div>
        <div className="col-3">
          <div className="d-flex justify-content-end">
            <button
              onClick={handleSubmit}
              type="submit"
              className={`d-btn d-btn--small d-btn-primary-outline mr-10`}
            >
              {tr("Фильтровать")}
            </button>
            <button
              onClick={clearHandler}
              type="button"
              className={`d-btn d-btn--small d-btn-danger-outline`}
            >
              {tr("Очистить")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filter;
